<app-global-loader></app-global-loader>

<ng-container *ngIf='isBrowserSupported'>
    <app-header [slideHeader]='slideHeader' [hasStickySideBar]='headerHasStickySideBar()'></app-header>

    <app-version-display></app-version-display>

    <app-side-menu
        *ngIf='loggedInUser'
        (toggleMenu)='handleMenuToggle($event)'
        [isBackDropEnabled]='sideMenuOptions.isBackDropEnabled'
        [isFixedBelowHeader]='sideMenuOptions.isFixedBelowHeader'
        [isFullWidth]='sideMenuOptions.isFullWidth'
        [menuItems]='sideMenuItems'
        [closeMenuAfterItemClick]='sideMenuOptions.closeMenuAfterItemClick'
        [hasStickySideBar]='sideMenuOptions.hasStickySideBar'
        [slideMode]='sideMenuOptions.slideMode'>
    </app-side-menu>

    <div [class.slide-content]='slideContent'
         [class.has-sticky-side-bar]='loggedInUser && sideMenuOptions.hasStickySideBar'
         [class.mobile]='isMobile'
         class='main-content'>
        <div class='content-container' [@routerTransition]='prepareRouterTransition(o)'>
            <router-outlet #o='outlet'></router-outlet>
        </div>
    </div>
</ng-container>
